import React from 'react'

import { Button, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'

import CampaignBanners from 'components/campaign-banners/CampaignBanners'
import { useCampaignBanners } from 'hooks/useCampaignBanners'
import { useCampaignReview } from 'hooks/useCampaignReview'

type BannersReviewProps = {
  back: (...args: any[]) => any
  next: (...args: any[]) => any
}

const BannersReview = ({ back, next }: BannersReviewProps) => {
  const { id } = useParams()
  const { data: review } = useCampaignReview(id)
  const customerId = review?.customerId
  const { data: banners } = useCampaignBanners(id)

  const disabled = (banners ?? []).some((banner: any) => banner.unsupported)

  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={{ sm: 12 }}>
          <CampaignBanners customerId={customerId ?? 0} />
        </Grid>

        <Grid size={{ sm: 12 }}>
          <Button color="primary" onClick={back}>
            Back
          </Button>
          <Button color="primary" disabled={disabled} onClick={next} variant="contained">
            Next
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}

export default BannersReview
